export default __webpack_public_path__ + "static/media/gnl7.75a35bf7.webp";